
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyCaV8Lx5xQ5R5H2_y9Q3xUoHwKruXeYv3g",
  authDomain: "balaji-saree.firebaseapp.com",
  projectId: "balaji-saree",
  storageBucket: "balaji-saree.firebasestorage.app",
  messagingSenderId: "12613424149",
  appId: "1:12613424149:web:87e85e1b5da624e863aa1c",
  measurementId: "G-GBYWJ6Z8D9"
 
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;


